import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a987e7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-remove__dialog" }
const _hoisted_2 = {
  key: 0,
  class: "confirm-remove__text"
}
const _hoisted_3 = {
  key: 1,
  class: "confirm-remove__text__app"
}
const _hoisted_4 = { class: "confirm-remove__footer" }

import { useI18n } from 'vue-i18n'
import { NImage, NEllipsis } from 'naive-ui'

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmRemoveNav',
  props: {
    text: null,
    img: null,
    name: null
  },
  emits: ["confirm", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'confirm'): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {




const { t } = useI18n()

const onOk = () => emit('confirm')
const onCancel = () => emit('close')

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.img)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.text), 1))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(t)('components.navigator.navs.isremove')) + " ", 1),
          _createVNode(_unref(NImage), {
            width: "16",
            height: "16",
            src: __props.img,
            "preview-disabled": "",
            class: "appImg"
          }, null, 8, ["src"]),
          _createVNode(_unref(NEllipsis), { class: "appName" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.name), 1)
            ]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(__props.text), 1)
        ])),
    _createElementVNode("footer", _hoisted_4, [
      _createVNode(_component_n_button, {
        class: "confirm-remove__btn",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_n_button, {
        class: "confirm-remove__btn",
        type: "error",
        onClick: onOk
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('components.navigator.navs.navRemove')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})